import { isValidPhoneNumber } from 'react-phone-number-input';

export const Validator = {
  name: 'phone_number',

  errorMessage: 'The :attribute is in invalid format.',

  validate: (value, requirement, attribute) => {
    return isValidPhoneNumber(value);
  },
};
